import React from "react";
import styles from "./Table.module.scss";
import TableRow from "../TableRow/TableRow";
import { useTranslation } from "react-i18next";

const Table = ({ data, hasHeader = true, isView = false, amountPayout }) => {
  const { t } = useTranslation();
  return (
    <>
      {hasHeader && <h2 className={styles.table__title}>{t("My Tokens")}</h2>}
      <div className={styles.table}>
        <div className={styles.table__body}>
          {data?.map((plant, i) => {
            const {
              created_at,
              purchase_date,
              id,
              representational_id,
              total_amount,
              plants_count,
            } = plant;
            return (
              <TableRow
                key={i}
                id={id}
                representational_id={representational_id}
                total_amount={total_amount}
                plants_count={plants_count}
                plants_purchase_date={purchase_date}
                isView={isView}
                amountPayout={amountPayout}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Table;
